"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_TYPES = exports.COLORS = void 0;
// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var COLORS = {
  // blue
  PRIMARY: [0x26, 0xb5, 0xf2],
  // gray
  SECONDARY: [0xaa, 0xaa, 0xaa],
  // yellow
  HIGHLIGHT: [0xff, 0xff, 0x00]
};
exports.COLORS = COLORS;
var EDIT_TYPES = {
  ADD_POSITION: 'addPosition',
  MOVE_POSITION: 'movePosition',
  TRANSLATING: 'translating',
  ADD_FEATURE: 'addFeature'
};
exports.EDIT_TYPES = EDIT_TYPES;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lZGl0b3ItbGF5ZXIvY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbIkNPTE9SUyIsIlBSSU1BUlkiLCJTRUNPTkRBUlkiLCJISUdITElHSFQiLCJFRElUX1RZUEVTIiwiQUREX1BPU0lUSU9OIiwiTU9WRV9QT1NJVElPTiIsIlRSQU5TTEFUSU5HIiwiQUREX0ZFQVRVUkUiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBO0FBQ0E7QUFJTyxJQUFNQSxNQUFNLEdBQUc7QUFDcEI7QUFDQUMsRUFBQUEsT0FBTyxFQUFFLENBQUMsSUFBRCxFQUFPLElBQVAsRUFBYSxJQUFiLENBRlc7QUFHcEI7QUFDQUMsRUFBQUEsU0FBUyxFQUFFLENBQUMsSUFBRCxFQUFPLElBQVAsRUFBYSxJQUFiLENBSlM7QUFLcEI7QUFDQUMsRUFBQUEsU0FBUyxFQUFFLENBQUMsSUFBRCxFQUFPLElBQVAsRUFBYSxJQUFiO0FBTlMsQ0FBZjs7QUFTQSxJQUFNQyxVQUFVLEdBQUc7QUFDeEJDLEVBQUFBLFlBQVksRUFBRSxhQURVO0FBRXhCQyxFQUFBQSxhQUFhLEVBQUUsY0FGUztBQUd4QkMsRUFBQUEsV0FBVyxFQUFFLGFBSFc7QUFJeEJDLEVBQUFBLFdBQVcsRUFBRTtBQUpXLENBQW5CIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IHtSR0JDb2xvcn0gZnJvbSAnQGtlcGxlci5nbC90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBDT0xPUlMgPSB7XG4gIC8vIGJsdWVcbiAgUFJJTUFSWTogWzB4MjYsIDB4YjUsIDB4ZjJdIGFzIFJHQkNvbG9yLFxuICAvLyBncmF5XG4gIFNFQ09OREFSWTogWzB4YWEsIDB4YWEsIDB4YWFdIGFzIFJHQkNvbG9yLFxuICAvLyB5ZWxsb3dcbiAgSElHSExJR0hUOiBbMHhmZiwgMHhmZiwgMHgwMF0gYXMgUkdCQ29sb3Jcbn07XG5cbmV4cG9ydCBjb25zdCBFRElUX1RZUEVTID0ge1xuICBBRERfUE9TSVRJT046ICdhZGRQb3NpdGlvbicsXG4gIE1PVkVfUE9TSVRJT046ICdtb3ZlUG9zaXRpb24nLFxuICBUUkFOU0xBVElORzogJ3RyYW5zbGF0aW5nJyxcbiAgQUREX0ZFQVRVUkU6ICdhZGRGZWF0dXJlJ1xufTtcbiJdfQ==